module.exports = __webpack_public_path__ + "img/instruction_1.eb48a8b6.jpg";